<template>
  <div v-if="post">
    <div class="postpage__header"
      style="background-image:url(https://images.pexels.com/photos/373543/pexels-photo-373543.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-6 col-xs-12 postpage__header__info" data-aos-once="true" data-aos="fade-down"
            data-aos-duration="400">
            <router-link :to="'/news/' " class="back-btn  button button--transparent-grad pulse">
              <span>
                Back
              </span>
            </router-link>
            <div class="postpage__header__image o-mobile" data-aos-once="true" data-aos-delay="500" data-aos="zoom-out"
              data-aos-duration="500" :style="'background-image:url('+proxyUrl + post.jetpack_featured_media_url +')'">
            </div>
            <p class="postpage__header__info__title" v-html="post.title.rendered">
            </p>
            <div class="postpage__header__info__body">
              <div class="category">News</div>
              <div class="date_icon">
                <img src="/static/cdn/date_h577wr.svg">
                <span>
                  4-5-2021
                </span>
              </div>
            </div>

          </div>
          <div class="col-md-6 col-sm-6 ">
            <div class="postpage__header__image hidden-mob" data-aos-once="true" data-aos-delay="500" data-aos="zoom-out"
              data-aos-duration="500" :style="'background-image:url('+ proxyUrl + post.jetpack_featured_media_url +')'">

            </div>

          </div>

        </div>
      </div>
    </div>
    <div class="container">
      <div class="news">

        <div class="news_body">
          <div class="row">

            <!-- BODY PAGE -->
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-12" data-aos-once="true" data-aos-delay="700" data-aos="fade-up"
                  data-aos-duration="600">
                  <div class="innerpage__content" v-html="post.content.rendered">
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="posts_section mt-10">
                    <div class="page_section_header">
                      <h2>
                        Recent News
                      </h2>
                      <!-- <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit eius recusandae quas at ipsa iste,
                        voluptatibus rem! Architecto, consequatur dignissimos et, earum aliquam nobis ducimus error
                        fugiat
                        autem, expedita non!
                      </p> -->
                    </div>
                    <div class="page_section_body" v-if="posts">
                      <div class="row">
                        <div class="col-sm-4 col-xs-12" v-for="item in posts.slice(0,3)">
                          <post data-aos="fade-up" typepost="col" data-aos-delay="100" data-aos-once="true" :post="item"
                            :key="item.id" :categories="categories" :media="medias"></post>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- SIDE PAGE -->
            <div class="col-md-3 col-xs-12">
              <side-bare></side-bare>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import GPost from '@/mixins/posts';
  import global from '@/mixins/global';
  import axios from 'axios';

  export default {
    mixins: [global,GPost],
   async created() {
    await this.pageUpdate();
    await this.getCategories();
    await this.getPosts();

    },
    data() {
      return {
        pageType: this.$route.params.type,
        pageId: this.$route.params.id,
        post: undefined,
      }
    },
    beforeRouteUpdate(to, from, next) {
      this.pageType = to.params.type;
      this.pageId = to.params.id;
      this.getPostData();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      next();
    },

    methods: {
     async pageUpdate() {
       await this.getPostData();
       await this.getCategories();
      },
      getPostData() {
        var $this = this;
       return axios.get( this.proxyUrl +'http://news.mobilityintel.com/wp-json/wp/v2/' + this.pageType + '/' + this.pageId, {
            headers: {
              'Content-Type': 'application/json'
            }
          }, ).then(function (response) {
              console.log("typeof::",  response.data)
              response.data.content.rendered = response.data.content.rendered.replaceAll('http://news.', $this.proxyUrl + 'http://news.');
              $this.post = response.data;

            })
      },
      }
    }

</script>

<style lang="scss">
  .news {
    @import "../../../assets/style/flexbox";
  }

  @import "../style";
  @import "./wpblock";
  .posts_section {
    margin-right: 31px;
  }

  .postpage__header__image {
    height: 239px;
    margin-top: 105px;
    background-size: cover;
    border-radius: 15px;
  }
.innerpage__content a:-webkit-any-link {
  color: rgb(255, 255, 255);
}
  .postpage__header:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    top: 0;
    left: 0;
    opacity: 0.9;
  }

  .postpage__header .container {
    position: relative;
    z-index: 2;
  }

  .postpage__header {
    position: relative;
    min-height: 302px;
    padding-bottom: 50px;

    @media screen and (min-width:768px) {
      height: 302px;
      padding-bottom: 0;

    }
  }


  p.postpage__header__info__title {
    color: white;
    font-size: 30px;

    margin-top: 152px;
    @media screen and (max-width:768px) {
      margin-top: 40px;
    }
  }

  .postpage__header__info__body {
    color: white;
    overflow: hidden;
  }

  .postpage__header__info__body .category {
    float: left;
    background-color: #24ad60;
    padding: 4px 12px;
  }

  .date_icon {
    float: left;
    margin-left: 21px;
    margin-top: 5px;
  }

  .innerpage__content {
    color: white;
    max-width: 674px;
  }

  .innerpage__content {
    min-height: 30vh;
  }

  .back-btn {
    margin-top: 74px;
    position: absolute  !important; 
  }

  .postpage__header__image.o-mobile.aos-init.aos-animate {
    margin-top: 160px;
  }

  @media screen and (max-width:768px) {
    .hidden-mob{
      display: none;
    }
    .news {
      margin-top: 27px;
    }
      .postpage__header__image.o-mobile.aos-init.aos-animate {
        margin-top: 133px;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/News/InnerPage/index.vue